import { datadogLogs } from '@datadog/browser-logs';

export const setOnboardingSessionToken = (token) => {
    localStorage.setItem('onboardingToken', token)
    setDatadogUserID(token);
}

export const setDatadogUserID = (token) => {
    if (!token) return false;

    const payload = parseJWT(token);
    if (!payload || !payload.memberid) return false;

    const userId = payload.memberid;
    datadogLogs.setUser({ id: userId });
    return true;
};

const parseJWT = (token) => {
    try {
        const payloadBase64 = token.split('.')[1];
        const decoded = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(decoded);
    } catch (e) {
        console.error('Invalid JWT', e);
        return null;
    }
}
